// extracted by mini-css-extract-plugin
module.exports = {"root":"InvestmentWarning_root__3y_O9"};